import React, {useLayoutEffect} from "react";
import {useAuthDispatcher} from "../context/AuthContext";
import {actionTypes, setLoginStateDispatch} from "../context/reducer";
import {getUserRefreshToken, setUserRefreshToken} from "../service/localStorage/LocalStorageService";
import {SnackbarHelper} from "../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../context/SnackBarContext";
import {LoginService} from "../serverService/login/LoginService";


export default function AuthorizationRoute(props) {

    const refreshToken = getUserRefreshToken()
    const dispatch = useAuthDispatcher()
    const service = new LoginService()

    const snackbar = new SnackbarHelper(useSnackbarDispatcher())

    useLayoutEffect(() => {
        if (typeof service !== 'undefined') {
            if (refreshToken !== null) {
                service.getUserTokenByRefreshToken(refreshToken)
                    .then(response => {

                        setUserRefreshToken(response.data.refresh_token)
                        dispatch(setLoginStateDispatch(
                            actionTypes.LOGIN,
                            response.data.access_token,
                            response.permissions))


                        // getAdminRolesFromServer(response.data.refresh_token, response.data.access_token)
                    }).catch(reason => {
                    dispatch({
                        type: actionTypes.LOGOUT,
                        loading: false,
                        loginState: false,
                        role: []
                    })
                })
            } else {
                dispatch({
                    type: actionTypes.LOGOUT,
                    loading: false,
                    loginState: false,
                    role: []
                })
            }
        }
    }, [dispatch, refreshToken])

    function getAdminRolesFromServer(refresh_token, access_token) {
        service.getAccessInfo(access_token)
            .then(response => {
                setUserRefreshToken(refresh_token)
                dispatch(setLoginStateDispatch(
                    actionTypes.LOGIN,
                    access_token,
                    response.permissions))
            }).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        })
    }

    return (<>{props.children}</>)
}